export default "__VITE_ASSET__7RaRCHO3__"